"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmojiPickerNavigation = EmojiPickerNavigation;
var _cn = require("@udecode/cn");
var _button = require("./button");
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
var getBarProperty = function getBarProperty(emojiLibrary, focusedCategory) {
  var width = 0;
  var position = 0;
  if (focusedCategory) {
    width = 100 / emojiLibrary.getGrid().size;
    position = focusedCategory ? emojiLibrary.indexOf(focusedCategory) * 100 : 0;
  }
  return {
    position: position,
    width: width
  };
};
function EmojiPickerNavigation(_ref) {
  var emojiLibrary = _ref.emojiLibrary,
    focusedCategory = _ref.focusedCategory,
    i18n = _ref.i18n,
    icons = _ref.icons,
    _onClick = _ref.onClick;
  var _getBarProperty = getBarProperty(emojiLibrary, focusedCategory),
    position = _getBarProperty.position,
    width = _getBarProperty.width;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("nav", {
    className: "mb-2.5 border-0 border-b border-solid border-b-border p-3",
    id: "emoji-nav",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "relative flex items-center",
      children: [emojiLibrary.getGrid().sections().map(function (_ref2) {
        var id = _ref2.id;
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
          "aria-label": i18n.categories[id],
          className: (0, _cn.cn)('size-6 grow fill-current text-muted-foreground hover:bg-transparent hover:text-foreground', id === focusedCategory && 'pointer-events-none fill-current text-primary'),
          onClick: function onClick() {
            return _onClick(id);
          },
          size: "icon",
          title: i18n.categories[id],
          type: "button",
          variant: "ghost",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: "size-5",
            children: icons.categories[id].outline
          })
        }, id);
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "absolute -bottom-3 left-0 h-0.5 w-full rounded-t-lg bg-primary opacity-100 transition-transform duration-200",
        style: {
          transform: "translateX(".concat(position, "%)"),
          visibility: "".concat(focusedCategory ? 'visible' : 'hidden'),
          width: "".concat(width, "%")
        }
      })]
    })
  });
}